export let routesObject = [
    {
        name: '32',
        routeCoordinates: [
            [53.1851, 50.0870], [53.1850, 50.0873], [53.1810, 50.0847], [53.1817, 50.0819], [53.1802, 50.0801], [53.1794, 50.0796], [53.1801, 50.0766], [53.1776, 50.0749], [53.1760, 50.0734], [53.1752, 50.0730], [53.1748, 50.0731], [53.1712, 50.0754], [53.1702, 50.0758], [53.1690, 50.0755], [53.1666, 50.0737], [53.1660, 50.0736], [53.1655, 50.0739], [53.1642, 50.0852], [53.1636, 50.0867], [53.1589, 50.0912], [53.1561, 50.0923], [53.1543, 50.0927], [53.1502, 50.0955], [53.1484, 50.0962], [53.1452, 50.0972], [53.1409, 50.1009], [53.1361, 50.1043], [53.1346, 50.1159], [53.1356, 50.1165], [53.1352, 50.1197], [53.1354, 50.1202], [53.1364, 50.1204], [53.1366, 50.1210], [53.1373, 50.1255], [53.1421, 50.1321], [53.1475, 50.1351], [53.1474, 50.1357], [53.1472, 50.1398], [53.1478, 50.1405], [53.1485, 50.1406], [53.1489, 50.1407], [53.1488, 50.1411], [53.1484, 50.1406], [53.1479, 50.1405], [53.1476, 50.1403], [53.1472, 50.1397], [53.1470, 50.1404], [53.1464, 50.1411], [53.1408, 50.1459], [53.1402, 50.1465], [53.1387, 50.1494], [53.1368, 50.1550]
        ],
        routeStops: [
            {
                stopName: 'пл. Революции',
                stopCoordinates: [53.185116, 50.086982]
            },
            {
                stopName: 'Степана Разина',
                stopCoordinates: [53.181603, 50.082093]
            },
            {
                stopName: 'Хлебная пл.',
                stopCoordinates: [53.179653, 50.07972]
            },
            {
                stopName: 'Водников',
                stopCoordinates: [53.179888, 50.076404]
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.14573, 50.096951],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140765, 50.10071],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135794, 50.105367],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.135498, 50.117041],
                stopName: 'Заправка'
            },
            {
                stopCoordinates: [53.137156, 50.124868],
                stopName: 'пос. Водников'
            },
            {
                stopCoordinates: [53.142323, 50.132548],
                stopName: 'Снежная'
            },
            {
                stopCoordinates: [53.147325, 50.136156],
                stopName: 'Кирзавод (ул. Центральная)'
            },
            {
                stopCoordinates: [53.148908, 50.141252],
                stopName: 'Сиреневый пер.'
            },
            {
                stopCoordinates: [53.136768, 50.155186],
                stopName: 'с/х Кряж (ул. Поселковая)'
            }
        ]
    },
    {
        name: '105',
        routeCoordinates:  [ [ 53.1922, 50.1229 ], [ 53.1925, 50.1220 ], [ 53.1868, 50.1182 ], [ 53.1868, 50.1167 ], [ 53.1884, 50.1101 ], [ 53.1837, 50.1067 ], [ 53.1853, 50.1001 ], [ 53.1828, 50.0985 ], [ 53.1853, 50.0885 ], [ 53.1855, 50.0886 ], [ 53.1858, 50.0886 ], [ 53.1860, 50.0883 ], [ 53.1862, 50.0878 ], [ 53.1862, 50.0874 ], [ 53.1860, 50.0870 ], [ 53.1858, 50.0867 ], [ 53.1854, 50.0867 ], [ 53.1852, 50.0869 ], [ 53.1850, 50.0873 ], [ 53.1810, 50.0846 ], [ 53.1816, 50.0818 ], [ 53.1803, 50.0802 ], [ 53.1794, 50.0796 ], [ 53.1802, 50.0766 ], [ 53.1755, 50.0731 ], [ 53.1749, 50.0731 ], [ 53.1707, 50.0757 ], [ 53.1699, 50.0757 ], [ 53.1692, 50.0755 ], [ 53.1667, 50.0738 ], [ 53.1660, 50.0736 ], [ 53.1657, 50.0739 ], [ 53.1654, 50.0746 ], [ 53.1642, 50.0853 ], [ 53.1636, 50.0868 ], [ 53.1582, 50.0917 ], [ 53.1548, 50.0926 ], [ 53.1525, 50.0939 ], [ 53.1496, 50.0958 ], [ 53.1456, 50.0971 ], [ 53.1360, 50.1043 ], [ 53.1303, 50.1086 ], [ 53.1191, 50.1209 ], [ 53.0929, 50.1501 ], [ 53.0914, 50.1500 ], [ 53.0911, 50.1505 ], [ 53.0910, 50.1516 ], [ 53.0904, 50.1528 ], [ 53.0539, 50.1935 ], [ 53.0461, 50.1854 ] ],
        routeStops: [
            {
                stopName: 'Пригородный автовокзал',
                stopCoordinates: [53.192274, 50.122854]
            },
            {
                stopName: 'Буянова (ул. Льва Толстого)',
                stopCoordinates: [53.187247, 50.115028]
            },
            {
                stopName: 'Стадион Динамо (ул. Братьев Коростелевых)',
                stopCoordinates: [53.187833, 50.109598]
            },
            {
                stopName: 'Ленинградская (ул. Братьев Коростелевых)',
                stopCoordinates: [53.183892, 50.106807]
            },
            {
                stopCoordinates: [53.184473, 50.099611],
                stopName: 'Троицкий рынок'
            },
            {
                stopCoordinates: [53.183963, 50.094000],
                stopName: 'Молодогвардейская (ул. Венцека)'
            },
            {
                stopCoordinates: [53.185108, 50.086949],
                stopName: 'пл. Революции'
            },
            {
                stopCoordinates: [53.179614, 50.079686],
                stopName: 'Хлебная пл.'
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.107741, 50.133458],
                stopName: 'Поворот на Южный Город'
            },
            {
                stopCoordinates: [53.085298, 50.158433],
                stopName: 'пос. Придорожный'
            },
            {
                stopCoordinates: [53.045606, 50.183892],
                stopName: 'АГЛОС'
            },
        ]
    },
    {
        name: '118',
        routeCoordinates:  [  [ 53.1922, 50.1229 ], [ 53.1925, 50.1220 ], [ 53.1868, 50.1182 ], [ 53.1868, 50.1167 ], [ 53.1884, 50.1101 ], [ 53.1837, 50.1067 ], [ 53.1853, 50.1001 ], [ 53.1828, 50.0985 ], [ 53.1853, 50.0885 ], [ 53.1855, 50.0886 ], [ 53.1858, 50.0886 ], [ 53.1860, 50.0883 ], [ 53.1862, 50.0878 ], [ 53.1862, 50.0874 ], [ 53.1860, 50.0870 ], [ 53.1858, 50.0867 ], [ 53.1854, 50.0867 ], [ 53.1852, 50.0869 ], [ 53.1850, 50.0873 ], [ 53.1810, 50.0846 ], [ 53.1816, 50.0818 ], [ 53.1803, 50.0802 ], [ 53.1794, 50.0796 ], [ 53.1802, 50.0766 ], [ 53.1755, 50.0731 ], [ 53.1749, 50.0731 ], [ 53.1707, 50.0757 ], [ 53.1699, 50.0757 ], [ 53.1692, 50.0755 ], [ 53.1667, 50.0738 ], [ 53.1660, 50.0736 ], [ 53.1657, 50.0739 ], [ 53.1654, 50.0746 ], [ 53.1642, 50.0853 ], [ 53.1636, 50.0868 ], [ 53.1582, 50.0917 ], [ 53.1548, 50.0926 ], [ 53.1525, 50.0939 ], [ 53.1496, 50.0958 ], [ 53.1456, 50.0971 ], [ 53.1360, 50.1043 ], [ 53.1303, 50.1086 ], [ 53.1191, 50.1209 ], [ 53.0929, 50.1501 ], [ 53.0914, 50.1500 ], [ 53.0911, 50.1505 ], [ 53.0910, 50.1516 ],[ 53.0514, 50.1962 ], [ 53.0300, 50.2198 ], [ 53.0143, 50.2374 ], [ 53.0006, 50.2522 ], [ 52.9733, 50.2766 ], [ 52.9669, 50.2728 ], [ 52.9562, 50.2426 ], [ 52.9146, 50.2420 ], [ 52.9019, 50.2314 ], [ 52.8936, 50.2300 ] ],
        routeStops: [
            {
                stopName: 'Пригородный автовокзал',
                stopCoordinates: [53.192274, 50.122854]
            },
            {
                stopName: 'Буянова (ул. Льва Толстого)',
                stopCoordinates: [53.187247, 50.115028]
            },
            {
                stopName: 'Стадион Динамо (ул. Братьев Коростелевых)',
                stopCoordinates: [53.187833, 50.109598]
            },
            {
                stopName: 'Ленинградская (ул. Братьев Коростелевых)',
                stopCoordinates: [53.183892, 50.106807]
            },
            {
                stopCoordinates: [53.184473, 50.099611],
                stopName: 'Троицкий рынок'
            },
            {
                stopCoordinates: [53.183963, 50.094000],
                stopName: 'Молодогвардейская (ул. Венцека)'
            },
            {
                stopCoordinates: [53.185108, 50.086949],
                stopName: 'пл. Революции'
            },
            {
                stopCoordinates: [53.179614, 50.079686],
                stopName: 'Хлебная пл.'
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.128065, 50.110759],
                stopName: 'Поворот на Южный Город'
            },
            {
                stopCoordinates: [53.085298, 50.158433],
                stopName: 'пос. Придорожный'
            },
            {
                stopCoordinates: [53.030056, 50.219641],
                stopName: 'Поворот на Самарский'
            },
            {
                stopCoordinates: [52.972674, 50.275116],
                stopName: 'Дубовый Умёт'
            },
            {
                stopCoordinates: [52.892538, 50.226997],
                stopName: 'Берёзовый Гай'
            },
        ]
    },
    {
        name: '177',
        routeCoordinates:   [ [ 53.1922, 50.1231 ], [ 53.1925, 50.1220 ], [ 53.1868, 50.1183 ], [ 53.1868, 50.1169 ], [ 53.1884, 50.1101 ], [ 53.1837, 50.1068 ], [ 53.1852, 50.1003 ], [ 53.1829, 50.0986 ], [ 53.1854, 50.0886 ], [ 53.1857, 50.0886 ], [ 53.1860, 50.0883 ], [ 53.1862, 50.0876 ], [ 53.1860, 50.0870 ], [ 53.1857, 50.0867 ], [ 53.1853, 50.0867 ], [ 53.1851, 50.0871 ], [ 53.1850, 50.0873 ], [ 53.1831, 50.0859 ], [ 53.1842, 50.0819 ], [ 53.1797, 50.0787 ], [ 53.1801, 50.0766 ], [ 53.1754, 50.0730 ], [ 53.1709, 50.0756 ], [ 53.1698, 50.0757 ], [ 53.1663, 50.0736 ], [ 53.1657, 50.0737 ], [ 53.1654, 50.0748 ], [ 53.1642, 50.0852 ], [ 53.1633, 50.0871 ], [ 53.1594, 50.0908 ], [ 53.1567, 50.0924 ], [ 53.1531, 50.0932 ], [ 53.1512, 50.0948 ], [ 53.1494, 50.0961 ], [ 53.1450, 50.0973 ], [ 53.1368, 50.1036 ], [ 53.1359, 50.1033 ], [ 53.1312, 50.0949 ], [ 53.1283, 50.0912 ], [ 53.1272, 50.0902 ], [ 53.0989, 50.0746 ], [ 53.0947, 50.0685 ], [ 53.0931, 50.0672 ], [ 53.0919, 50.0667 ], [ 53.0892, 50.0650 ], [ 53.0867, 50.0624 ], [ 53.0864, 50.0616 ], [ 53.0863, 50.0611 ], [ 53.0860, 50.0610 ], [ 53.0857, 50.0611 ], [ 53.0856, 50.0616 ], [ 53.0856, 50.0623 ], [ 53.0855, 50.0634 ], [ 53.0846, 50.0667 ], [ 53.0829, 50.0706 ], [ 53.0820, 50.0725 ], [ 53.0811, 50.0764 ], [ 53.0807, 50.0798 ], [ 53.0810, 50.1187 ], [ 53.0830, 50.1205 ], [ 53.0859, 50.1210 ] ],
        routeStops: [
            {
                stopName: 'Пригородный автовокзал',
                stopCoordinates: [53.192274, 50.122854]
            },
            {
                stopName: 'Буянова (ул. Льва Толстого)',
                stopCoordinates: [53.187247, 50.115028]
            },
            {
                stopName: 'Стадион Динамо (ул. Братьев Коростелевых)',
                stopCoordinates: [53.187833, 50.109598]
            },
            {
                stopName: 'Ленинградская (ул. Братьев Коростелевых)',
                stopCoordinates: [53.183892, 50.106807]
            },
            {
                stopCoordinates: [53.184473, 50.099611],
                stopName: 'Троицкий рынок'
            },
            {
                stopCoordinates: [53.183963, 50.094000],
                stopName: 'Молодогвардейская (ул. Венцека)'
            },
            {
                stopCoordinates: [53.185108, 50.086949],
                stopName: 'пл. Революции'
            },
            {
                stopCoordinates: [53.179614, 50.079686],
                stopName: 'Хлебная пл.'
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.132713, 50.097180],
                stopName: 'Ильинская церковь'
            },
            {
                stopCoordinates: [53.117375, 50.085238],
                stopName: 'Бакинская улица'
            },
            {
                stopCoordinates: [53.097878, 50.072795],
                stopName: 'Расширение'
            },
            {
                stopCoordinates: [53.084311, 50.067062],
                stopName: 'Стромиловское кладбище'
            },
            {
                stopCoordinates: [53.080635, 50.089525],
                stopName: 'Верхняя Подстёпновка'
            },
            {
                stopCoordinates: [53.085363, 50.120942],
                stopName: 'Преображенка'
            },
        ]
    },
    {
        name: '114',
        routeCoordinates:   [ [ 53.1922, 50.1231 ], [ 53.1925, 50.1220 ], [ 53.1868, 50.1183 ], [ 53.1868, 50.1169 ], [ 53.1884, 50.1101 ], [ 53.1837, 50.1068 ], [ 53.1852, 50.1003 ], [ 53.1829, 50.0986 ], [ 53.1854, 50.0886 ], [ 53.1857, 50.0886 ], [ 53.1860, 50.0883 ], [ 53.1862, 50.0876 ], [ 53.1860, 50.0870 ], [ 53.1857, 50.0867 ], [ 53.1853, 50.0867 ], [ 53.1851, 50.0871 ], [ 53.1850, 50.0873 ], [ 53.1831, 50.0859 ], [ 53.1842, 50.0819 ], [ 53.1797, 50.0787 ], [ 53.1801, 50.0766 ], [ 53.1754, 50.0730 ], [ 53.1709, 50.0756 ], [ 53.1698, 50.0757 ], [ 53.1663, 50.0736 ], [ 53.1657, 50.0737 ], [ 53.1654, 50.0748 ], [ 53.1642, 50.0852 ], [ 53.1633, 50.0871 ], [ 53.1594, 50.0908 ], [ 53.1567, 50.0924 ], [ 53.1531, 50.0932 ], [ 53.1512, 50.0948 ], [ 53.1494, 50.0961 ], [ 53.1450, 50.0973 ], [ 53.1368, 50.1036 ], [ 53.1359, 50.1033 ], [ 53.1312, 50.0949 ], [ 53.1283, 50.0912 ], [ 53.1272, 50.0902 ], [ 53.0989, 50.0746 ], [ 53.0947, 50.0685 ], [ 53.0931, 50.0672 ], [ 53.0919, 50.0667 ], [ 53.0892, 50.0650 ], [ 53.0867, 50.0624 ], [ 53.0864, 50.0616 ], [ 53.0863, 50.0611 ], [ 53.0860, 50.0610 ], [ 53.0857, 50.0611 ], [ 53.0857, 50.0610 ], [ 53.0850, 50.0609 ], [ 53.0710, 50.0257 ], [ 53.0703, 50.0174 ], [ 53.0723, 50.0107 ], [ 53.0742, 49.9969 ], [ 53.0832, 49.9992 ], [ 53.0865, 49.9979 ], [ 53.0917, 49.9836 ]  ],
        routeStops: [
            {
                stopName: 'Пригородный автовокзал',
                stopCoordinates: [53.192274, 50.122854]
            },
            {
                stopName: 'Буянова (ул. Льва Толстого)',
                stopCoordinates: [53.187247, 50.115028]
            },
            {
                stopName: 'Стадион Динамо (ул. Братьев Коростелевых)',
                stopCoordinates: [53.187833, 50.109598]
            },
            {
                stopName: 'Ленинградская (ул. Братьев Коростелевых)',
                stopCoordinates: [53.183892, 50.106807]
            },
            {
                stopCoordinates: [53.184473, 50.099611],
                stopName: 'Троицкий рынок'
            },
            {
                stopCoordinates: [53.183963, 50.094000],
                stopName: 'Молодогвардейская (ул. Венцека)'
            },
            {
                stopCoordinates: [53.185108, 50.086949],
                stopName: 'пл. Революции'
            },
            {
                stopCoordinates: [53.179614, 50.079686],
                stopName: 'Хлебная пл.'
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.132713, 50.097180],
                stopName: 'Ильинская церковь'
            },
            {
                stopCoordinates: [53.117375, 50.085238],
                stopName: 'Бакинская улица'
            },
            {
                stopCoordinates: [53.097878, 50.072795],
                stopName: 'Расширение'
            },
            {
                stopCoordinates: [53.081659, 50.053092],
                stopName: '1-я дачная'
            },
            {
                stopCoordinates: [53.070779, 50.025018],
                stopName: 'АЗС'
            },
            {
                stopCoordinates: [53.077177, 49.997407],
                stopName: 'СДТ Рябинушка'
            },
            {
                stopCoordinates: [53.089205, 49.989716],
                stopName: '72-й квартал'
            },

        ]
    },
    {
        name: '48к',
        routeCoordinates:   [ [ 53.1853, 50.0886 ], [ 53.1850, 50.0880 ], [ 53.1850, 50.0872 ], [ 53.1831, 50.0860 ], [ 53.1842, 50.0818 ], [ 53.1797, 50.0787 ], [ 53.1802, 50.0765 ], [ 53.1753, 50.0731 ], [ 53.1749, 50.0730 ], [ 53.1711, 50.0755 ], [ 53.1700, 50.0759 ], [ 53.1663, 50.0737 ], [ 53.1658, 50.0737 ], [ 53.1653, 50.0747 ], [ 53.1642, 50.0855 ], [ 53.1627, 50.0877 ], [ 53.1600, 50.0904 ], [ 53.1576, 50.0919 ], [ 53.1547, 50.0926 ], [ 53.1528, 50.0938 ], [ 53.1494, 50.0961 ], [ 53.1455, 50.0971 ], [ 53.1365, 50.1039 ], [ 53.1306, 50.0940 ], [ 53.1281, 50.0908 ], [ 53.1187, 50.0863 ], [ 53.1200, 50.0767 ], [ 53.1199, 50.0753 ], [ 53.1149, 50.0633 ], [ 53.1074, 50.0716 ], [ 53.1098, 50.0773 ], [ 53.1135, 50.0730 ], [ 53.1172, 50.0820 ] ],
        routeStops: [
            {
                stopCoordinates: [53.185108, 50.086949],
                stopName: 'пл. Революции'
            },
            {
                stopName: 'Клуб Дзержинского',
                stopCoordinates: [53.183553, 50.084658]
            },
            {
                stopName: 'пл. Дзержинского',
                stopCoordinates: [53.180289, 50.079130]
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.132713, 50.097180],
                stopName: 'Ильинская церковь'
            },
            {
                stopCoordinates: [53.129649, 50.092567],
                stopName: 'Улица Войкова'
            },
            {
                stopCoordinates: [53.121686, 50.087394],
                stopName: 'Гастроном'
            },
            {
                stopCoordinates: [53.118885, 50.085093],
                stopName: 'Бакинская улица'
            },
            {
                stopCoordinates: [53.117295, 50.068903],
                stopName: 'Калининградская улица'
            },
            {
                stopCoordinates: [53.114509, 50.075604],
                stopName: 'Молодёжный переулок'
            },
        ]
    },
    {
        name: '48д',
        routeCoordinates:   [ [ 53.1927, 50.1231 ], [ 53.1922, 50.1251 ], [ 53.1871, 50.1215 ], [ 53.1868, 50.1213 ], [ 53.1868, 50.1169 ], [ 53.1901, 50.1034 ], [ 53.1828, 50.0985 ], [ 53.1854, 50.0886 ], [ 53.1853, 50.0886 ], [ 53.1850, 50.0880 ], [ 53.1850, 50.0872 ], [ 53.1831, 50.0860 ], [ 53.1842, 50.0818 ], [ 53.1797, 50.0787 ], [ 53.1802, 50.0765 ], [ 53.1753, 50.0731 ], [ 53.1749, 50.0730 ], [ 53.1711, 50.0755 ], [ 53.1700, 50.0759 ], [ 53.1663, 50.0737 ], [ 53.1658, 50.0737 ], [ 53.1653, 50.0747 ], [ 53.1642, 50.0855 ], [ 53.1627, 50.0877 ], [ 53.1600, 50.0904 ], [ 53.1576, 50.0919 ], [ 53.1547, 50.0926 ], [ 53.1528, 50.0938 ], [ 53.1494, 50.0961 ], [ 53.1455, 50.0971 ], [ 53.1365, 50.1039 ], [ 53.1306, 50.0940 ], [ 53.1281, 50.0908 ], [ 53.1187, 50.0863 ], [ 53.1200, 50.0767 ], [ 53.1199, 50.0753 ], [ 53.1149, 50.0633 ], [ 53.1074, 50.0716 ], [ 53.1098, 50.0773 ], [ 53.1135, 50.0730 ], [ 53.1172, 50.0820 ] ],
        routeStops: [
            {
                stopName: 'Пригородный автовокзал',
                stopCoordinates: [53.192274, 50.122854]
            },
            {
                stopName: 'Поликлиника (Железнодорожный вокзал)',
                stopCoordinates: [53.1871,50.1216]
            },
            {
                stopName: 'Буянова (ул. Льва Толстого)',
                stopCoordinates: [53.187247, 50.115028]
            },
            {
                stopCoordinates: [53.184473, 50.099611],
                stopName: 'Троицкий рынок'
            },
            {
                stopCoordinates: [53.184057, 50.094033],
                stopName: 'Молодогвардейская улица'
            },
            {
                stopCoordinates: [53.185108, 50.086949],
                stopName: 'пл. Революции'
            },
            {
                stopName: 'Клуб Дзержинского',
                stopCoordinates: [53.183553, 50.084658]
            },
            {
                stopName: 'пл. Дзержинского',
                stopCoordinates: [53.180289, 50.079130]
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.132713, 50.097180],
                stopName: 'Ильинская церковь'
            },
            {
                stopCoordinates: [53.129649, 50.092567],
                stopName: 'Улица Войкова'
            },
            {
                stopCoordinates: [53.121686, 50.087394],
                stopName: 'Гастроном'
            },
            {
                stopCoordinates: [53.118885, 50.085093],
                stopName: 'Бакинская улица'
            },
            {
                stopCoordinates: [53.117295, 50.068903],
                stopName: 'Калининградская улица'
            },
            {
                stopCoordinates: [53.114509, 50.075604],
                stopName: 'Молодёжный переулок'
            },
        ]
    },
    {
        name:'128',
        routeCoordinates:  [ [ 53.1926, 50.1232 ], [ 53.1928, 50.1224 ], [ 53.1868, 50.1182 ], [ 53.1868, 50.1170 ], [ 53.1884, 50.1101 ], [ 53.1837, 50.1066 ], [ 53.1853, 50.1002 ], [ 53.1828, 50.0985 ], [ 53.1853, 50.0885 ], [ 53.1856, 50.0887 ], [ 53.1859, 50.0885 ], [ 53.1861, 50.0881 ], [ 53.1861, 50.0875 ], [ 53.1860, 50.0870 ], [ 53.1858, 50.0867 ], [ 53.1854, 50.0867 ], [ 53.1851, 50.0870 ], [ 53.1850, 50.0872 ], [ 53.1810, 50.0846 ], [ 53.1817, 50.0818 ], [ 53.1802, 50.0801 ], [ 53.1794, 50.0796 ], [ 53.1802, 50.0766 ], [ 53.1775, 50.0747 ], [ 53.1758, 50.0732 ], [ 53.1754, 50.0730 ], [ 53.1750, 50.0729 ], [ 53.1747, 50.0731 ], [ 53.1709, 50.0756 ], [ 53.1704, 50.0757 ], [ 53.1699, 50.0756 ], [ 53.1693, 50.0756 ], [ 53.1665, 50.0736 ], [ 53.1660, 50.0736 ], [ 53.1657, 50.0738 ], [ 53.1654, 50.0741 ], [ 53.1644, 50.0842 ], [ 53.1640, 50.0858 ], [ 53.1633, 50.0870 ], [ 53.1588, 50.0912 ], [ 53.1572, 50.0920 ], [ 53.1543, 50.0926 ], [ 53.1500, 50.0956 ], [ 53.1484, 50.0963 ], [ 53.1453, 50.0972 ], [ 53.1387, 50.1023 ], [ 53.1364, 50.1037 ], [ 53.1318, 50.0958 ], [ 53.1282, 50.0908 ], [ 53.1147, 50.0842 ], [ 53.1051, 50.0784 ], [ 53.0987, 50.0745 ], [ 53.0948, 50.0684 ], [ 53.0885, 50.0644 ], [ 53.0866, 50.0623 ], [ 53.0863, 50.0611 ], [ 53.0851, 50.0609 ], [ 53.0842, 50.0592 ], [ 53.0810, 50.0511 ], [ 53.0769, 50.0391 ], [ 53.0723, 50.0292 ], [ 53.0706, 50.0276 ], [ 53.0708, 50.0259 ], [ 53.0703, 50.0175 ], [ 53.0722, 50.0109 ], [ 53.0731, 50.0054 ], [ 53.0742, 49.9969 ], [ 53.0826, 49.9990 ], [ 53.0867, 49.9977 ], [ 53.0957, 49.9719 ], [ 53.0966, 49.9721 ], [ 53.0964, 49.9703 ], [ 53.1009, 49.9582 ], [ 53.0998, 49.9571 ] ],
        routeStops: [
            {
                stopName: 'Пригородный автовокзал',
                stopCoordinates: [53.192274, 50.122854]
            },
            {
                stopName: 'Буянова (ул. Льва Толстого)',
                stopCoordinates: [53.187247, 50.115028]
            },
            {
                stopName: 'Стадион Динамо (ул. Братьев Коростелевых)',
                stopCoordinates: [53.187833, 50.109598]
            },
            {
                stopName: 'Ленинградская (ул. Братьев Коростелевых)',
                stopCoordinates: [53.183892, 50.106807]
            },
            {
                stopCoordinates: [53.184473, 50.099611],
                stopName: 'Троицкий рынок'
            },
            {
                stopCoordinates: [53.183963, 50.094000],
                stopName: 'Молодогвардейская (ул. Венцека)'
            },
            {
                stopCoordinates: [53.185108, 50.086949],
                stopName: 'пл. Революции'
            },
            {
                stopCoordinates: [53.179614, 50.079686],
                stopName: 'Хлебная пл.'
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.132713, 50.097180],
                stopName: 'Ильинская церковь'
            },
            {
                stopCoordinates: [53.117375, 50.085238],
                stopName: 'Бакинская улица'
            },
            {
                stopCoordinates: [53.097878, 50.072795],
                stopName: 'Расширение'
            },
            {
                stopCoordinates: [53.081659, 50.053092],
                stopName: '1-я дачная'
            },
            {
                stopCoordinates: [53.070779, 50.025018],
                stopName: 'АЗС'
            },
            {
                stopCoordinates: [53.077177, 49.997407],
                stopName: 'СДТ Рябинушка'
            },
            {
                stopCoordinates: [53.089205, 49.989716],
                stopName: '72-й квартал'
            },
            {
                stopCoordinates: [53.099150, 49.963387],
                stopName: 'Улица Островского'
            },
        ]
    }
        ,{
    name:'140',
        routeCoordinates: [ [ 53.1927, 50.1233 ], [ 53.1929, 50.1224 ], [ 53.1868, 50.1182 ], [ 53.1868, 50.1167 ], [ 53.1884, 50.1100 ], [ 53.1837, 50.1067 ], [ 53.1853, 50.1002 ], [ 53.1828, 50.0985 ], [ 53.1850, 50.0898 ], [ 53.1805, 50.0868 ], [ 53.1817, 50.0818 ], [ 53.1805, 50.0803 ], [ 53.1794, 50.0797 ], [ 53.1790, 50.0795 ], [ 53.1769, 50.0803 ], [ 53.1766, 50.0801 ], [ 53.1778, 50.0751 ], [ 53.1754, 50.0730 ], [ 53.1748, 50.0732 ], [ 53.1707, 50.0757 ], [ 53.1698, 50.0758 ], [ 53.1667, 50.0738 ], [ 53.1661, 50.0737 ], [ 53.1655, 50.0739 ], [ 53.1641, 50.0856 ], [ 53.1630, 50.0874 ], [ 53.1584, 50.0915 ], [ 53.1567, 50.0922 ], [ 53.1542, 50.0927 ], [ 53.1498, 50.0958 ], [ 53.1490, 50.0962 ], [ 53.1453, 50.0972 ], [ 53.1411, 50.1007 ], [ 53.1363, 50.1037 ], [ 53.1308, 50.0943 ], [ 53.1278, 50.0906 ], [ 53.1139, 50.0839 ], [ 53.0988, 50.0746 ], [ 53.0941, 50.0678 ], [ 53.0888, 50.0648 ], [ 53.0865, 50.0621 ], [ 53.0861, 50.0608 ], [ 53.0852, 50.0608 ], [ 53.0842, 50.0599 ], [ 53.0780, 50.0420 ], [ 53.0722, 50.0289 ], [ 53.0648, 50.0234 ], [ 53.0628, 50.0202 ], [ 53.0615, 50.0194 ], [ 53.0575, 50.0187 ], [ 53.0557, 50.0175 ], [ 53.0508, 50.0099 ], [ 53.0466, 50.0066 ], [ 53.0287, 49.9933 ], [ 53.0239, 49.9856 ], [ 53.0224, 49.9842 ], [ 53.0182, 49.9826 ], [ 53.0161, 49.9814 ], [ 53.0096, 49.9757 ], [ 53.0057, 49.9701 ], [ 53.0012, 49.9610 ], [ 52.9964, 49.9549 ], [ 52.9876, 49.9266 ], [ 52.9837, 49.9134 ], [ 52.9824, 49.9023 ], [ 52.9832, 49.8807 ], [ 52.9918, 49.8380 ], [ 52.9957, 49.8051 ], [ 52.9973, 49.7689 ], [ 52.9977, 49.7680 ], [ 52.9971, 49.7673 ], [ 52.9962, 49.7278 ], [ 52.9952, 49.7245 ], [ 52.9857, 49.7144 ], [ 52.9827, 49.7112 ], [ 52.9860, 49.7146 ] ],
        routeStops: [
            {
                stopName: 'Пригородный автовокзал',
                stopCoordinates: [53.192274, 50.122854]
            },
            {
                stopName: 'Буянова (ул. Льва Толстого)',
                stopCoordinates: [53.187247, 50.115028]
            },
            {
                stopName: 'Стадион Динамо (ул. Братьев Коростелевых)',
                stopCoordinates: [53.187833, 50.109598]
            },
            {
                stopName: 'Ленинградская (ул. Братьев Коростелевых)',
                stopCoordinates: [53.183892, 50.106807]
            },
            {
                stopCoordinates: [53.184473, 50.099611],
                stopName: 'Троицкий рынок'
            },
            {
                stopCoordinates: [53.183963, 50.094000],
                stopName: 'Молодогвардейская (ул. Венцека)'
            },
            {
                stopCoordinates: [53.179614, 50.079686],
                stopName: 'Хлебная пл.'
            },
            {
                stopName: 'Кутякова',
                stopCoordinates: [53.177243, 50.074514]
            },
            {
                stopCoordinates: [53.167803, 50.074569],
                stopName: 'Тракторная'
            },
            {
                stopCoordinates: [53.165687, 50.073370],
                stopName: 'Хлебозавод №3'
            },
            {
                stopCoordinates: [53.164841, 50.079734],
                stopName: 'Дарвина'
            },
            {
                stopCoordinates: [53.160344, 50.089728],
                stopName: 'Ростовский пер.'
            },
            {
                stopCoordinates: [53.157525, 50.091668],
                stopName: 'с/х Волгарь'
            },
            {
                stopCoordinates: [53.145607, 50.096820],
                stopName: 'Казачий переезд'
            },
            {
                stopCoordinates: [53.140703, 50.100709],
                stopName: '4-я Кряжская'
            },
            {
                stopCoordinates: [53.135222, 50.104567],
                stopName: 'Кряж'
            },
            {
                stopCoordinates: [53.132713, 50.097180],
                stopName: 'Ильинская церковь'
            },
            {
                stopCoordinates: [53.117375, 50.085238],
                stopName: 'Бакинская улица'
            },
            {
                stopCoordinates: [53.097878, 50.072795],
                stopName: 'Расширение'
            },
            {
                stopCoordinates: [53.069420, 50.026447],
                stopName: 'Воскресенка'
            },
            {
                stopCoordinates: [53.054388, 50.015137],
                stopName: 'Совхоз Молодая Гвардия'
            },
            {
                stopCoordinates: [52.996530, 49.954672],
                stopName: 'Поворот на Журавли'
            },
            {
                stopCoordinates: [52.990157, 49.934328],
                stopName: 'Молодогвардейский'
            },
            {
                stopCoordinates: [52.997241, 49.775470],
                stopName: 'Посёлок Нагорный'
            },
            {
                stopCoordinates: [52.994455, 49.723414],
                stopName: 'ЧМУ'
            },
            {
                stopCoordinates: [52.983427, 49.711800],
                stopName: 'Стадион Луч'
            },
        ]
    }
]
